import { render, staticRenderFns } from "./PortalAlteracoes.vue?vue&type=template&id=ecacbf12&scoped=true"
import script from "./PortalAlteracoes.vue?vue&type=script&lang=js"
export * from "./PortalAlteracoes.vue?vue&type=script&lang=js"
import style0 from "./PortalAlteracoes.vue?vue&type=style&index=0&id=ecacbf12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecacbf12",
  null
  
)

export default component.exports